/// <reference path="./types/aos.d.ts" />

import { setUpThemeSwitcher } from './themes';
import { projectSetup } from './projects';
import { experienceSetup } from './experience';
import { educationSetup } from './education';
import { loadGists } from './gists';
import { loadNotes } from './notes'
import { Tooltip, Modal } from 'bootstrap';

globalThis.mobileWidth = 800;
globalThis.articleSlideDurationMs = 500;
globalThis.useAOS = false;

OnDocReady(globalSetup);
OnDocReady(experienceSetup);
OnDocReady(educationSetup);
OnDocReady(projectSetup); // calls skillsSetup
OnDocReady(loadVoicesWhenAvailable);

function globalSetup () {

	setUpThemeSwitcher();
	setupScrollbar();
	addAOSElements();

	// Equivalent to jQuery's $(window).on("resize", doSomething());
	window.addEventListener('resize', () => {
		setupScrollbar();
		toggleSidebar();
	});

	$('#sidebar').on('click', '.sidebarCollapse', function () {
		$('#sidebar').toggleClass('active');
		toggleSidebar();

		// close dropdowns
		$('.collapse.in').toggleClass('in');
		// and also adjust aria-expanded attributes we use for the open/closed arrows
		// in our CSS
		$('a[aria-expanded=true]').attr('aria-expanded', 'false');
	});

	/* Scroll transition to anchor */
	$("a.toscroll").on('click', function() {
		var url = $(this).attr("href");
		var hash = url.substring(url.indexOf("#")+1);
		goToSection('#' + hash, globalThis.articleSlideDurationMs);
		return false;
	});

	$(".arrow-prev a").on('click', function() {
		slideLeft();
		return false;
	});

	$(".arrow-next a").on('click', function() {
		slideRight();
		return false;
	});

	$("article").on('click', function() {
		if ($( window ).width() >= globalThis.mobileWidth && '#' + $(this).attr('id') !== window.location.hash)
			goToSection('#' + $(this).attr('id'), globalThis.articleSlideDurationMs);
	});

	$('.collapse-button').on('click', function() {
		var icon = $(this).find('.fa-solid');
		if (icon.hasClass('fa-toggle-off')) {
			icon.removeClass('fa-toggle-off');
			icon.addClass('fa-toggle-on');
		}
		else {
			icon.removeClass('fa-toggle-on');
			icon.addClass('fa-toggle-off');
		}
	});

	$("#contact-form").on("submit", function(e) {

		var url = $(this).attr("action");

		function showModal(title: string, data: string) {
			$('#contact-modal .modal-title').html(title);
			$('#contact-modal .modal-body p').text(data);

			var contactModal = new Modal(document.getElementById('contact-modal'));
			contactModal.show();
		}
		/* MangaD - disabled recaptcha
		if (grecaptcha.getResponse().length === 0) {
			showModal("<i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>&nbsp;&nbsp;&nbsp;Recaptcha", "Please check the recaptcha!");
		}
		else {*/

			const name = (document.querySelector('#contact-form input[name="name"]') as HTMLInputElement).value;
			const phone = (document.querySelector('#contact-form input[name="phone"]') as HTMLInputElement).value;
			const website = (document.querySelector('#contact-form input[name="website"]') as HTMLInputElement).value;
			const email = (document.querySelector('#contact-form input[name="email"]') as HTMLInputElement).value;
			const subject = (document.querySelector('#contact-form input[name="subject"]') as HTMLInputElement).value;
			const message = (document.querySelector('#contact-form textarea[name="message"]') as HTMLTextAreaElement).value;
			
			fetch (url, {
				cache: 'no-cache',
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json; charset=utf-8',
				},
				body: JSON.stringify({name, phone, website, email, subject, message})
			})
			.then(response => response.json())
			.then(response => {
				if (!response.success) throw response.message;
				showModal("<i class=\"fa fa-check\" aria-hidden=\"true\"></i>&nbsp;&nbsp;&nbsp;Success", response.message);
			})
			.catch(e => {
				showModal("<i class=\"fa fa-times\" aria-hidden=\"true\"></i>&nbsp;&nbsp;&nbsp;Error", e);
			});
			
/*
			$.ajax({
				type: "POST",
				url: url,
				data: $("#contact-form").serialize(),
				success: function(data) {
					showModal("<i class=\"fa fa-check\" aria-hidden=\"true\"></i>&nbsp;&nbsp;&nbsp;Success", data);
				},
				error: function(data) {
					showModal("<i class=\"fa fa-times\" aria-hidden=\"true\"></i>&nbsp;&nbsp;&nbsp;Error", data.responseText);
				}
			});
			*/
			/* MangaD - disabled recaptcha
			grecaptcha.reset();
		}*/

		e.preventDefault();
	});

	/* TO TOP */
	$('.totop-link').on('click', function() {
		$('html, body').animate({
			scrollTop: $($(this).attr('href')).offset().top
		}, 500);
		return false;
	});
	if ($(window).width() < globalThis.mobileWidth) {
		if (0 === $(this).scrollTop()) {
			$('.totop-link').toggle();
		}
	}

	/// STARTUP Stuff
	// Check if hash to go to article is in URL
	if (window.location.hash != '') {
		goToSection(window.location.hash, 0);
	} else {
		$(".arrow-prev a").hide();
		$('#about .mCustomScrollBox').focus();
	}

	createTooltips('.defaultTooltip');
	createTooltips('.skillTooltip');

	/// LOADER
	setTimeout(function() {
		$('.wrapper').css('visibility','visible');
		$('body').addClass('loaded');

		initAOS(); // Init AoS after removing the loader
	}, 0);

	setUpTabs();

	loadGists();
	loadNotes();
}

document.onscroll = function(evt) {
	if ($(window).width() < globalThis.mobileWidth) {
		var currentTop = $(this).scrollTop();
		if (0 !== currentTop && $('.totop-link').css('display') === 'none') {
			$('.totop-link').toggle();
		}
		else if (0 === currentTop) {
			$('.totop-link').toggle();
		}
	}
}

/* Fix auto scroll on refresh on mobile view */
$(window).on('beforeunload', function() {
	if (window.location.hash != '') {
		goToSection(window.location.hash, 0);
	}
});

document.addEventListener('keydown', function(e: KeyboardEvent) {
	if ((e.target as HTMLElement).tagName === "INPUT") return;
	switch(e.key) {
		case "Left": // IE/Edge specific value
    	case "ArrowLeft":
			slideLeft();
			break;
		case "Right": // IE/Edge specific value
		case "ArrowRight":
			slideRight();
			break;
		default: return; // exit this handler for other keys
	}
	e.preventDefault(); // prevent the default action (scroll / move caret)
});

function slideLeft() {
	if (window.location.hash.substring(1) !== $("article:first").attr('id')) {
		goToSection('#' + $(window.location.hash).prev().attr('id'), globalThis.articleSlideDurationMs);
	}
	else {
		$(".arrow-prev a").hide();
	}
}

function slideRight() {
	if (window.location.hash === '' || window.location.hash.substring(1) === $("article:first").attr('id')) {
		goToSection('#' + $("article:nth-of-type(2)").attr('id'), globalThis.articleSlideDurationMs);
	} else if (window.location.hash.substring(1) !== $("article:last").attr('id')) {
		goToSection('#' + $(window.location.hash).next().attr('id'), globalThis.articleSlideDurationMs);
	}
	if (window.location.hash.substring(1) === $("article:last").attr('id')) {
		$(".arrow-next a").hide();
	}
	$(".arrow-prev a").show();
}

export function goToSection(hash: string, duration: number) {
	if (!$(hash).offset()) return;
	$('html, body').animate({
		scrollTop: $(hash).offset().top - 20
	}, duration);
	$('#content').animate({
		// Scroll position is current scroll position + offset of article (relative to scroll position) - sidebar - content padding
		scrollLeft: $("#content").scrollLeft() + $(hash).offset().left - $('#sidebar').width() - parseInt($('#content').css("padding-left"))
	}, duration);
	window.location.hash = hash;
	$('#sidebar-menu li').removeClass("active");
	$('a[href="' + hash + '"]').parent().addClass("active");
	/* Icon active */
	$(".panel .sec-icon").removeClass("active-sec");
	$(hash + " .sec-icon").addClass("active-sec");
	/* Hide arrow if first or last element*/
	hideArrows();
	$(hash + ' .mCustomScrollBox')[0]?.focus();
}

// Check if arrows should be visible
function hideArrows() {
	$(".arrow-prev a").show();
	$(".arrow-next a").show();
	if (window.location.hash.substring(1) === '' || window.location.hash.substring(1) === $("article:first").attr('id')) {
		$(".arrow-prev a").hide();
	}
	else if (window.location.hash.substring(1) === $("article:last").attr('id')) {
		$(".arrow-next a").hide();
	}
}

function toggleSidebar() {
	if ($(window).width() < globalThis.mobileWidth) {
		$('.sidebar-header .profile-info strong').removeClass('sidebarCollapse');
		$('.sidebar-header').removeClass('sidebarCollapse');
	} else if ($('#sidebar').hasClass("active")) {
		$('.sidebar-header .profile-info strong').removeClass('sidebarCollapse');
		$('.sidebar-header').addClass('sidebarCollapse');
	} else {
		$('.sidebar-header .profile-info strong').addClass('sidebarCollapse');
		$('.sidebar-header').removeClass('sidebarCollapse');
	}
}

function printArticle(hash: string) {
	const hashEl = $(hash).parent();
	var openWindow = window.open("", "title", "attributes");
	openWindow.document.write(hashEl.html());
	openWindow.document.close();
	openWindow.focus();
	openWindow.print();
	//openWindow.close();
}


function setupScrollbar() {
	if ($( window ).width() >= globalThis.mobileWidth) {
		$("#sidebar-menu").mCustomScrollbar({
			theme: "minimal",
			callbacks:{
				onScroll: debounce(function() {
					// Trigger AOS refresh on scroll
					if (globalThis.useAOS) AOS.refresh();
				}, 100) // 100ms debounce delay
			}
		});

		$(".panel-body").mCustomScrollbar({
			theme: "minimal-dark",
			axis: "y",
			callbacks:{
				onScroll: debounce(function() {
					// Trigger AOS refresh on scroll
					if (globalThis.useAOS) AOS.refresh();
				}, 100) // 100ms debounce delay
			},
			advanced: {
				updateOnContentResize: true,
				autoScrollOnFocus: false // Stop the scrollbar from auto scrolling when
				// a modal is opened (e.g. click on "Read More" on a skill), or an element is focused
			}
		});
	} else {
		$("#sidebar-menu").mCustomScrollbar("destroy");
		$(".panel-body").mCustomScrollbar("destroy");
	}
}

function debounce(func: TimerHandler, wait: number) {
	let timeout: number;
	return function() {
		clearTimeout(timeout);
		timeout = setTimeout(func, wait);
	};
}

function addAOSElements() {
	if (globalThis.useAOS) {

		// Load AOS CSS
		const link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.css";
		link.integrity = "sha512-1cK78a1o+ht2JcaW6g8OXYwqpev9+6GqOkz9xmBN9iUUhIndKtxwILGWYOSibOKjLsEdjyjZvYDq/cZwNeak0w==";
		link.crossOrigin = "anonymous";
		link.referrerPolicy = "no-referrer";
		document.head.appendChild(link);

		// Load AOS JS
		const script = document.createElement("script");
		script.src = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js";
		script.integrity = "sha512-A7AYk1fGKX6S2SsHywmPkrnzTZHrgiVT7GcQkLGDe2ev0aWb8zejytzS8wjo7PGEXKqJOrjQ4oORtnimIRZBtw==";
		script.crossOrigin = "anonymous";
		script.referrerPolicy = "no-referrer";
		document.body.appendChild(script);
	}
}

function initAOS() {
	if (globalThis.useAOS) {
		// Initialize AOS
		AOS.init({
			duration: 800, // Animation duration in ms
			easing: 'linear', // Animation easing
			once: true, // Whether animation should happen only once
			disable: false, // Boolean or function. AOS will be disabled on mobile if true
			// Specify the scroll container
			// Not directly supported, but AOS.refresh can handle updates
		});
	}
}

/**
 * Function to refresh Animate on Scroll. Because I use malihu Custom Scrollbar,
 * AOS.refresh must be called on the `onScroll` event.
 */
export function refreshAOS() {
	if (globalThis.useAOS) AOS.refresh();
}

// Equivalent to jQuery's $(document).ready(setup);
// Source: https://codetonics.com/javascript/detect-document-ready/
export function OnDocReady(callbackFunction: VoidFunction) {
	if (document.readyState != 'loading') {
		callbackFunction();
	}
	else {
		document.addEventListener("DOMContentLoaded", callbackFunction);
	}
}

/**
 * Creates the Popper.js tooltips.
 * 
 * @param className The class name of the tooltips to create.
 * @param options The options for the tooltip.
 * @returns An array with the created tooltip objects.
 */
export function createTooltips(className: string, options?: Partial<Tooltip.Options>): Tooltip {
	const tooltipTriggerList = [].slice.call(document.querySelectorAll(className))
	const tooltips = tooltipTriggerList.map(function (tooltipTriggerEl: HTMLElement) {
		return new Tooltip(tooltipTriggerEl, options)
	});
	return tooltips;
}

/**
 * Destroys the tooltips associated with a class.
 * 
 * @param className The class the tooltips are associated with.
 */
export function destroyTooltips(className: string): void {
	const tooltipElements = document.querySelectorAll(className);

	tooltipElements.forEach((tooltipEl: HTMLElement) => {
		const tooltipInstance = Tooltip.getInstance(tooltipEl); // Retrieve the tooltip instance
		if (tooltipInstance) {
			tooltipInstance.dispose(); // Destroy the tooltip if it exists
		}
	});
}

/**
 * Initiates the read more elements.
 *
 * @link https://stephenscaff.github.io/read-smore/
 */
export function initReadMore() {
	// Init JS
	const ReadSmore = globalThis.readSmore;

	// target all read more elements
	const readMoreEls = document.querySelectorAll('.js-read-smore');
	
	// Init - This function may be called after dynamically adding
	// new elements to the DOM. In that case it will cause the exsting
	// elements to be reinitialized. Hence we don't call it like this.
	//ReadSmore(readMoreEls).init();

	const elementsToInit: Element[] = [];

	readMoreEls.forEach((element) => {
		const nextSibling = element.nextElementSibling;

		if (!(nextSibling && nextSibling.classList.contains('read-smore__link-wrap'))) {
			elementsToInit.push(element); // Add the element to the array if it needs initialization
		}
	});

	if (elementsToInit.length > 0) {
		ReadSmore(elementsToInit).init();
	}
}

/**
 * Sets up tab navigation for elements with the `data-toggle="tab"` attribute.
 * Prevents the default URL change and shows the tab content when a tab is clicked.
 */
export function setUpTabs() {
	$('a[data-toggle="tab"]').on('click', function (e) {
		e.preventDefault();  // Prevent URL change
		$(this).tab('show');  // Show the tab content
	});
}

/**
 * Loads the voices for the Web Speech API when they are available.
 */
// https://stackoverflow.com/a/61963317/3049315
function loadVoicesWhenAvailable () {
	if (!window.speechSynthesis) {
		throw new Error('Browser does not support speech synthesis')
	}
	globalThis.voices = window.speechSynthesis.getVoices();
	globalThis.voiceLocaleMap = {};
	window.speechSynthesis.cancel();

	if (globalThis.voices.length === 0) {
		return setTimeout(function () { loadVoicesWhenAvailable() }, 100)
	}
	//console.log('Voices loaded:', globalThis.voices.length);
}
